/**
 * LaunchDarkly.js
 * desc: Launch Darkly component
 * note: initializes SDK and returns provider or no-op wrapper
 */
'use strict';

import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';


const LaunchDarkly = async (user) => {
    const clientSideID = window.Ym.LAUNCH_DARKLY_CLIENT_ID;
    let provider = ({ children }) => children;

    // if account id exists, setup provider
    // note: clients may potentially opt out of feature flags
    if (clientSideID) {
        const config = {
            clientSideID,
            // seconds; on expiry the provider boots with bootstrap/default flags
            // and picks up live flags on the SDK's ready event instead of hanging
            timeout: 5,
            options: { bootstrap:'localStorage' },
            reactOptions: { useCamelCaseFlagKeys:false },
            user: {
                key: user.userDto?.id,
                name: user.name,
                email: user.email,
                custom: {
                    clientId: window.Ym.CLIENT_ID,
                    domain: window.location.hostname,
                    language: user.userDto?.languageTag?.substring(0, 2),
                    locale: user.userDto?.languageTag,
                },
            },
        };

        provider = await asyncWithLDProvider(config);
    }

    return provider;
};

export default LaunchDarkly;
